const orderTagsByName = ({tags, ascending = true}) =>
  [...tags].sort((a, b) => {
    const tagA = a.name;
    const tagB = b.name;
    return ascending ? tagA.localeCompare(tagB) : tagB.localeCompare(tagA);
  });

export default orderTagsByName;
